export default __webpack_public_path__ + "static/media/nr1.00dc8d80.jpg";